export const MEDIAOBJECT_SHOW_RESET = 'MEDIAOBJECT_SHOW_RESET';
export const MEDIAOBJECT_SHOW_SET_ERROR = 'MEDIAOBJECT_SHOW_SET_ERROR';
export const MEDIAOBJECT_SHOW_SET_RETRIEVED = 'MEDIAOBJECT_SHOW_SET_RETRIEVED';
export const MEDIAOBJECT_SHOW_TOGGLE_LOADING = 'MEDIAOBJECT_SHOW_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/mediaobject/show/mutation_types.js